"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEqual = exports.entries = void 0;
const json_1 = require("@stoplight/json");
const isEqualWith = require("lodash.isequalwith");
function entries(o) {
    return (0, json_1.isPlainObject)(o) ? Object.entries(o) : [];
}
exports.entries = entries;
function isEqual(left, right) {
    return isEqualWith(left, right, (value, other, indexOrKey) => {
        if (indexOrKey === 'id')
            return true;
        return;
    });
}
exports.isEqual = isEqual;
//# sourceMappingURL=utils.js.map